export const NOTIFICATION = Object.freeze({
  LIST: "/notification-app",
  READ: (id: string) => `/notification-app/read/${id}`,
  READ_ALL: `notification-app/read-all`,
  DELETE: (id: string) => `/notification-app/${id}`,
});
